import type { StaticPageListItemDetails, StaticPageListResponse } from '~/types/StaticPageList';

export const useSpecialOffersStore = defineStore('special-offers', {
  actions: {
    async getSpecialOffers(page: string | null) {
      try {
        let options = {};
        if (page) options = { query: { page } };

        const { data } = await useCustomFetch<StaticPageListResponse>('/info/special-offers', options);

        if (data.value) {
          return data.value;
        }
      } catch (e) {
        if (e && process.env.NODE_ENV !== 'production') {
          console.error(e);
        }
      }
    },

    async getSpecialOffersItemBySlug(slug: string, skipError?: boolean) {
      try {
        const { data } = await useCustomFetch<{ data: StaticPageListItemDetails }>(
          `/info/special-offers/${slug}`,
          {},
          '1',
          skipError,
        );

        if (data.value) {
          return data.value.data;
        } else {
          return null;
        }
      } catch (e) {
        if (e && process.env.NODE_ENV !== 'production') {
          console.error(e);
        }
        return null;
      }
    },
  },
});
